// Date 2020-07-22 11:00:00

import emActProcessDefinitionRegister from "@/store/em/workflow/EmActProcessDefinitionRegisterStore.js";
import emActProcessStatus from "@/store/em/workflow/EmActProcessStatusStore.js";
import emActProcessVariable from "@/store/em/workflow/EmActProcessVariableStore.js";

const genericEntities = [
    'emActProcessDefinitionRegister',
    'emActProcessStatus',
    'emActProcessVariable'
]

const entities = {
    emActProcessDefinitionRegister,
    emActProcessStatus,
    emActProcessVariable
}

export {genericEntities}

export default entities